import OpenSeadragon from "openseadragon";

const findEdge = (eventInfo, element) => {
  const rect = element.getBoundingClientRect();
  const x = eventInfo.originalEvent.x - rect.left;
  const y = eventInfo.originalEvent.y - rect.top;
  const isTop = y <= 5;
  const isBottom = y >= rect.height - 5;
  const isLeft = x <= 5;
  const isRight = x >= rect.width - 5;

  if (isTop && isLeft) {
    return "top_left";
  }
  if (isTop && isRight) {
    return "top_right";
  }
  if (isBottom && isLeft) {
    return "bottom_left";
  }
  if (isBottom && isRight) {
    return "bottom_right";
  }
  if (isTop && x > rect.width / 2 - 2.5 && x < rect.width / 2 + 2.5) {
    return "top";
  }
  if (isBottom && x > rect.width / 2 - 2.5 && x < rect.width / 2 + 2.5) {
    return "bottom";
  }
  if (isLeft && y > rect.height / 2 - 2.5 && y < rect.height / 2 + 2.5) {
    return "left";
  }
  if (isRight && y > rect.height / 2 - 2.5 && y < rect.height / 2 + 2.5) {
    return "right";
  }
  return undefined;
};

const selectOverlay = (viewer, element, selectedOverlay) => {
  viewer.currentOverlays.forEach((item) => {
    document.getElementById(item.element.id).classList.remove("selected");
    // class removed from here and selected item set to null in overlay details under type setSelectedOverlayRedux
    document.getElementById(item.element.id).classList.remove("temp-selected");
  });
  element.classList.add("selected");
  // Create a new ref object with the current value
  const newSelectedOverlay = { ...selectedOverlay, current: element };
  document.querySelector(".openseadragon-canvas").focus();
  return newSelectedOverlay;
};

const resizeAndDragOverlay = (e, edge, overlay, viewer, cursor, pageNumber) => {
  const delta = viewer.viewport.deltaPointsFromPixels(e.delta);
  const viewerBounds = viewer.world.getItemAt(pageNumber - 1).getBounds();
  const boundsWidthPoint = viewerBounds.width + viewerBounds.x;
  const boundsHeightPoint = viewerBounds.height + viewerBounds.y;
  let newOverLayBounds = null;

  if (cursor !== "grabbing") {
    // if(overlay.bounds.x + delta.x <= viewerBounds.x || overlay.bounds.y + delta.y <= viewerBounds.y || overlay.bounds.width - delta.x <= 0 || overlay.bounds.height - delta.y <= 0)
    // 	return;
    switch (edge) {
      case "top_left":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x + delta.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y + delta.y)),
          Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width - delta.x)),
          Math.max(1, Math.min(viewerBounds.height, overlay.bounds.height - delta.y))
        );
        break;
      case "top_right":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y + delta.y)),
          Math.max(
            1,
            Math.min(boundsWidthPoint - overlay.bounds.x, overlay.bounds.width + delta.x)
          ),
          Math.max(
            1,
            Math.min(boundsHeightPoint - overlay.bounds.y, overlay.bounds.height - delta.y)
          )
        );
        break;
      case "bottom_left":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x + delta.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y)),
          Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width - delta.x)),
          Math.max(
            1,
            Math.min(boundsHeightPoint - overlay.bounds.y, overlay.bounds.height + delta.y)
          )
        );
        break;
      case "bottom_right":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y)),
          Math.max(
            1,
            Math.min(boundsWidthPoint - overlay.bounds.x, overlay.bounds.width + delta.x)
          ),
          Math.max(
            1,
            Math.min(boundsHeightPoint - overlay.bounds.y, overlay.bounds.height + delta.y)
          )
        );
        break;
      case "top":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y + delta.y)),
          Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width)),
          Math.max(1, Math.min(viewerBounds.height, overlay.bounds.height - delta.y))
        );
        break;
      case "bottom":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y)),
          Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width)),
          Math.max(
            1,
            Math.min(boundsHeightPoint - overlay.bounds.y, overlay.bounds.height + delta.y)
          )
        );
        break;
      case "left":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x + delta.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y)),
          Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width - delta.x)),
          Math.max(1, Math.min(viewerBounds.height, overlay.bounds.height))
        );
        break;
      case "right":
        newOverLayBounds = new OpenSeadragon.Rect(
          Math.max(viewerBounds.x, Math.min(boundsWidthPoint, overlay.bounds.x)),
          Math.max(viewerBounds.y, Math.min(boundsHeightPoint, overlay.bounds.y)),
          Math.max(
            1,
            Math.min(boundsWidthPoint - overlay.bounds.x, overlay.bounds.width + delta.x)
          ),
          Math.max(1, Math.min(viewerBounds.height, overlay.bounds.height))
        );
        break;
      default:
        break;
    }
  } else {
    newOverLayBounds = new OpenSeadragon.Rect(
      Math.max(
        viewerBounds.x,
        Math.min(boundsWidthPoint - overlay.bounds.width, overlay.bounds.x + delta.x)
      ),
      Math.max(
        viewerBounds.y,
        Math.min(boundsHeightPoint - overlay.bounds.height, overlay.bounds.y + delta.y)
      ),
      Math.max(1, Math.min(viewerBounds.width, overlay.bounds.width)),
      Math.max(1, Math.min(viewerBounds.height, overlay.bounds.height))
    );
  }
  overlay.update(newOverLayBounds);
  overlay.drawHTML(viewer.overlaysContainer, viewer.viewport);
};

const addDragMouseEvents = (viewer, element, overlay, selectedOverlay) => {
  let edge = "";
  let cursor = "";
  let preOverlayBounds = overlay.bounds;
  let dragEvent = false;
  const mouseTracker = new OpenSeadragon.MouseTracker({
    element,
    preProcessEventHandler(eventInfo) {
      const modifiedEventInfo = { ...eventInfo };
      switch (eventInfo.eventType) {
        case "pointerdown":
          element.classList.add("grabbing-element");
          edge = findEdge(eventInfo, element);
          cursor = window.getComputedStyle(eventInfo.originalEvent.target).cursor;
          modifiedEventInfo.preventGesture = false;
          break;
        case "pointerup":
          element.classList.remove("grabbing-element");
          edge = "";
          cursor = "";
          modifiedEventInfo.preventGesture = false;
          break;
        case "click":
          // select element/overlay
          selectOverlay(viewer, element, selectedOverlay);
          break;

        case "contextmenu":
          modifiedEventInfo.preventDefault = true;
          break;
        default:
          break;
      }
      return modifiedEventInfo;
    },
    dragHandler(e) {
      dragEvent = true;
      resizeAndDragOverlay(e, edge, overlay, viewer, cursor, element.dataset.pageNumber);
    },
    releaseHandler() {
      // dragEndHanlder is not called sometimes so used releaseHandler in this way
      if (dragEvent) {
        const boundingBox = viewer.world
          .getItemAt(element.dataset.pageNumber - 1)
          .viewportToImageRectangle(overlay.bounds);
        preOverlayBounds = overlay.bounds;
        dragEvent = false;
      }
    },
  }).setTracking(true);
  return () => {
    mouseTracker.destroy();
  };
};

const makeEdgesAndCorners = (overlayElement) => {
  // corners/edge
  for (let i = 1; i <= 4; i += 1) {
    const edge = document.createElement("div");
    edge.className = `edge edge-${i}`;
    edge.classList.add("manual-edge");
    overlayElement.appendChild(edge);
  }

  // edge centers
  for (let i = 1; i <= 4; i += 1) {
    const center = document.createElement("div");
    center.className = `edge center-${i}`;
    center.classList.add("manual-edge");
    overlayElement.appendChild(center);
  }

  // remove href from overlays
  overlayElement.removeAttribute("href");
};

const unSelectOverlay = (viewerRef, selectedOverlay) => {
  viewerRef.current.currentOverlays.forEach((item) => {
    document.getElementById(item.element.id).classList.remove("selected");
  });
  // Create a new ref object instead of modifying the parameter
  const newSelectedOverlay = { ...selectedOverlay, current: null };
  return newSelectedOverlay;
};

const panToOverlay = (viewerRef, selectedObject, pageNumber) => {
  const viewportRect = viewerRef.current.world
    .getItemAt(pageNumber - 1)
    .imageToViewportRectangle(
      selectedObject.x,
      selectedObject.y,
      selectedObject.w,
      selectedObject.h
    );
  const constraints = viewerRef.current.viewport.getConstrainedBounds();
  if (
    constraints.height + constraints.y < viewportRect.y + viewportRect.height ||
    viewportRect.y - 10 < constraints.y
  ) {
    const tileCenter = viewerRef.current.world
      .getItemAt(pageNumber - 1)
      .getBounds()
      .getCenter();
    viewerRef.current.viewport.panTo(new OpenSeadragon.Point(tileCenter.x, viewportRect.y));
  }
};

export { makeEdgesAndCorners, addDragMouseEvents, selectOverlay, unSelectOverlay, panToOverlay };
